<script lang="ts">
import { PropType } from 'vue'

type ShootingType =
  | 'ORIGINAL'
  | 'ORIGINAL_LPC'
  | 'STAMPED_LPC'
  | 'ORIGINAL_CROPPED_LPC'
  | 'STAMPED_CROPPED_LPC'
  | 'ORIGINAL_CROPPED'
  | 'STAMPED_CROPPED'
  | 'BACKGROUND_CROPPED'
  | 'STAMPED'
  | 'OPTIMIZED'

export default {
  name: 'ShootingTitleType',
  props: {
    type: {
      type: String as PropType<ShootingType>,
      required: true
    },
    counter: {
      type: String as PropType<string | null>,
      default: null
    }
  },
  computed: {
    convertTitle() {
      const cases = {
        ORIGINAL: this.$t('shooting.types.original'),
        ORIGINAL_LPC: this.$t('shooting.types.originalLpc'),
        STAMPED_LPC: this.$t('shooting.types.stampedLpc'),
        ORIGINAL_CROPPED_LPC: this.$t('shooting.types.originalCroppedLpc'),
        STAMPED_CROPPED_LPC: this.$t('shooting.types.stampedCroppedLpc'),
        ORIGINAL_CROPPED: this.$t('shooting.types.originalCropped'),
        STAMPED_CROPPED: this.$t('shooting.types.stampedCropped'),
        BACKGROUND_CROPPED: this.$t('shooting.types.backgroundCropped'),
        STAMPED: this.$t('shooting.types.stamped'),
        OPTIMIZED: this.$t('shooting.types.optimized')
      }
      const title = cases[this.type]

      if (!title) {
        const errorMessage = `[ShootingTitleType] Unknown type "${this.type}"`
        console.error(errorMessage)
        return ''
      }

      return title
    }
  }
}
</script>

<template>
  <h3>
    {{ convertTitle }}<span v-if="counter"> ({{ counter }})</span>
  </h3>
</template>
